export enum CheckoutStatus {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Initiated = 'initiated',
    InTransit = 'in-transit',
    Scheduled = 'scheduled',
    PartiallyPaid = 'partially-paid',
    PartiallyRefunded = 'partially-refunded',
    Charged = 'charged',
    Failed = 'failed',
    Canceled = 'canceled',
    Refunded = 'refunded',
    RefundInitiated = 'refund-initiated',
    RefundFailed = 'refund-failed',
    Disputed = 'disputed',
    MarkedAsPaid = 'marked-as-paid',
    Overdue = 'overdue',
    Defaulted = 'defaulted',
}
